import styled from 'styled-components'

import { Tooltip } from '@ucheba/ui/components/Tooltip/touch'

export const Title = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`

export const TooltipStyled = styled(Tooltip)`
  svg {
    width: 24px;
    height: 24px;

    cursor: help;
  }
`
